import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimataDoubleYpsili';
const args = {};

export class OligonKentimataDoubleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
